import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { InvoiceFilterService } from '../../shared/filter/invoice-filter.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { selectInvoiceTableQuery } from '../../../store/invoice-table/invoice-table.state';
import { Observable } from 'rxjs';
import { InvoiceQuery } from '../../../models/invoice-query';
import { FilterAssist } from '../../../models/filter-assist';
import { debounceTime, filter, map, mergeMap, switchMap } from 'rxjs/operators';
import { invoiceTableAddAssist, invoiceTableRemoveAssist } from '../../../store/invoice-table/invoice-table.actions';
import { MatOption } from '@angular/material/core';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { IconComponent } from '../../shared/icon/icon.component';
import { AsyncPipe } from '@angular/common';
import { MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { MatFormField } from '@angular/material/form-field';

@Component({
    selector: 'app-invoice-table-filter',
    templateUrl: './invoice-table-filter.component.html',
    styleUrls: ['./invoice-table-filter.component.scss'],
    imports: [ReactiveFormsModule, MatFormField, MatChipGrid, MatChipRow, MatChipRemove, IconComponent, MatInput, MatChipInput, MatAutocompleteTrigger, MatAutocomplete, MatOption, AsyncPipe]
})
export class InvoiceTableFilterComponent implements OnInit {

    @ViewChild('termsInput') termsInput: ElementRef<HTMLInputElement>;

    constructor(private invoiceFilterService: InvoiceFilterService, private store: Store<AppState>) {
    }

    searchForm = new UntypedFormGroup({
        terms: new UntypedFormControl('')
    });

    query$: Observable<InvoiceQuery> = this.store.select(selectInvoiceTableQuery);
    activeAssists$: Observable<FilterAssist[]> = this.query$.pipe(
        switchMap((query) => this.invoiceFilterService.activeAssists(query))
    );
    offeredAssists$: Observable<FilterAssist[]> = this.searchForm.valueChanges.pipe(
        debounceTime(200),
        map(form => form.terms),
        filter(terms => typeof terms === 'string'),
        mergeMap(terms => this.invoiceFilterService.autocompleteTerms(terms))
    );

    ngOnInit(): void {
    }

    onAssistSelection(assist: FilterAssist): void {
        this.store.dispatch(invoiceTableAddAssist({ id: assist.id, parameter: assist.parameter }));
        this.termsInput.nativeElement.value = '';
        this.searchForm.get('terms').setValue('');
    }

    onRemoveAssist(id: string): void {
        this.store.dispatch(invoiceTableRemoveAssist({ id }));
    }

}
